module.exports = "https://cdn.dove.it/_next/static/public/assets/work-with-us/CEO-doveit.1669ba1bf81a8e25cca8690c93228b8b.jpg";